import Vue from 'vue';
import { ToggleButton } from 'vue-js-toggle-button';

Vue.component('ToggleButton', ToggleButton);
